import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxes, faClipboardList, faShoppingCart, faStore } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../contexts/AuthContext';
import { useBranding } from '../contexts/BrandingContext';

// Default neutral colors
const defaultColors = {
  primary: '#2c3e50',
  secondary: '#34495e',
  active: 'rgba(52, 152, 219, 0.2)', // Light blue with transparency
  hover: 'rgba(52, 152, 219, 0.1)' // Lighter blue with transparency
};

function Navigation() {
  const location = useLocation();
  const { user } = useAuth();
  const { primaryColor } = useBranding();

  const NavLink = ({ to, icon, children }) => {
    const isActive = location.pathname === to;
    return (
      <Nav.Link
        as={Link}
        to={to}
        className={isActive ? 'active' : ''}
        style={{
          backgroundColor: isActive ? defaultColors.active : 'transparent',
          borderLeft: isActive ? `4px solid ${primaryColor || defaultColors.primary}` : '4px solid transparent',
          color: 'white',
          padding: '0.75rem 1.5rem',
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          transition: 'all 0.3s ease',
          textDecoration: 'none',
          fontSize: '0.95rem',
          fontWeight: isActive ? '600' : '400'
        }}
      >
        <FontAwesomeIcon icon={icon} />
        <span>{children}</span>
      </Nav.Link>
    );
  };

  return (
    <Nav className="flex-column">
      {/* Retail users: Products and My Orders */}
      {user?.isRetail && (
        <>
          <NavLink to="/products" icon={faStore}>
            Products
          </NavLink>
          <NavLink to="/external-orders" icon={faShoppingCart}>
            My Orders
          </NavLink>
        </>
      )}

      {/* Non-retail users: Inventory and Orders */}
      {!user?.isRetail && (
        <>
          <NavLink to="/inventory" icon={faBoxes}>
            Inventory
          </NavLink>
          <NavLink to="/orders" icon={faClipboardList}>
            Orders
          </NavLink>
        </>
      )}
    </Nav>
  );
}

export default Navigation;
